import {type FC, useRef} from 'react';
import {CSSTransition} from 'react-transition-group';

import styled from 'styled-components';

import type {Props} from './types';

import {View} from '../../../../uikit/View';
import {web} from './styles';

const Container = styled(View)<{$animationDuration: number}>`
  ${web};
`;

export const Backdrop: FC<Props> = ({animationDuration, isHiding}) => {
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      appear
      classNames="backdrop"
      in={!isHiding}
      nodeRef={nodeRef}
      timeout={animationDuration}
    >
      <Container $animationDuration={animationDuration} ref={nodeRef} />
    </CSSTransition>
  );
};
